/* eslint-disable no-undef, id-match, no-console, react-hooks/exhaustive-deps, no-shadow, sonarjs/cognitive-complexity */
/* google */
import jwt_decode from 'jwt-decode';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Cookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { PAGE_TYPES } from '../../config/constants/page-types';
import COOKIES from '../../config/cookies/cookies';
import { LINKS_GLOBAL_WOWCHER } from '../../config/links/links';
import {
  COOKIE_SUBSCRIBED_EXPIRES,
  SITE_LIVINGSOCIAL_IE,
} from '../../config/setup/setup';
import { GOOGLE_ID } from '../../config/social/config';
import {
  AN_ERROR_OCCURED,
  INVALID_GOOGLE_TOKEN_ID,
  PREFORMATTED_STRINGS,
} from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import commonCookiesOptions from '../../helpers/commonCookiesOptions';
import { removeCookie, setCookie } from '../../helpers/cookieSetter';
import {
  loginGoogleUser,
  registerGoogleUser,
  showErrorToast,
} from '../../helpers/googleServiceAPI';
import {
  onGoogleLoginSuccess,
  subscribeGoogleUser,
} from '../../helpers/googleServiceInternal';
import { isLightBoxAllowed } from '../../helpers/lightbox';
import { handleLightboxLocation } from '../../helpers/location';
import { pathLocationInfo } from '../../helpers/url';
import { setLoadingState } from '../../redux/actions/loading';
import { setLightbox } from '../../redux/actions/user';
import { LOADING_STATUS } from '../../redux/reducers/loading';
import useToast from '../_generic/toast/UseToast';

const isIframeVisible = (iframe) => {
  let isVisible = false;
  const iframeRect = iframe.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;

  if (
    ((iframeRect.top >= 0 && iframeRect.top <= windowHeight) ||
      (iframeRect.bottom <= windowHeight && iframeRect.bottom >= 0)) &&
    ((iframeRect.left >= 0 && iframeRect.left <= windowWidth) ||
      (iframeRect.right <= windowWidth && iframeRect.right >= 0))
  ) {
    isVisible = true;
  }

  return isVisible;
};

const GoogleOneTap = ({ registration = false, setUserEmail, setIsNewUser }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const router = useRouter();
  const CLIENT_ID =
    GOOGLE_ID[process.env.NEXT_PUBLIC_ENVIRONMENT || 'dev'][
      process.env.NEXT_PUBLIC_SITE || 'wowcher'
    ];
  const wowcherOrVoucher =
    PREFORMATTED_STRINGS.brandTerminology.Wowcher_or_voucher;
  const [showText, setShowText] = useState(false);
  const [bottomMargin, setBottomMargin] = useState('180px');
  const [topMargin, setTopMargin] = useState('220px');
  let mobileHeight;
  const showConfirmation = Cookies.load(COOKIES.showConfirmation);
  const [locations] = useSelector((state) => [state.locations.locations]);
  const { isLocationPage } = pathLocationInfo(router.asPath, locations);
  const customerToken = Cookies.load(COOKIES.customerToken);
  const isCheckoutOrAddon =
    router.asPath.includes(PAGE_TYPES.checkout) ||
    router.asPath.includes(PAGE_TYPES.orderAddon);
  const hideOneTap = isCheckoutOrAddon;

  const registerOneTapUser = async ({ authTwo, dispatch, toast, token }) => {
    try {
      const response = await registerGoogleUser(token);

      if (response.data) {
        subscribeGoogleUser(email, registration, response.data.isNewEmail);
        setIsNewUser(true);
        onGoogleLoginSuccess(authTwo, dispatch);
      } else {
        dispatch(setLoadingState(LOADING_STATUS.READY));
        showErrorToast(response.message || AN_ERROR_OCCURED, toast);
      }
    } catch (error) {
      dispatch(setLoadingState(LOADING_STATUS.READY));
      showErrorToast(error.message || AN_ERROR_OCCURED, toast);
    }
  };
  const loginOneTapUser = async ({
    authTwo,
    dispatch,
    email,
    registration,
    toast,
    token,
  }) => {
    Cookies.save(COOKIES.brandCookie, 'bypass_temp', {
      ...commonCookiesOptions,
      COOKIE_SUBSCRIBED_EXPIRES,
    });
    if (Cookies.load(COOKIES.userInfo)) {
      Cookies.remove(COOKIES.userInfo, {
        domain: `.${process.env.NEXT_PUBLIC_DOMAIN_NAME}`,
        path: '/',
      });
    }
    dispatch(setLoadingState(LOADING_STATUS.LOADING));

    try {
      const response = await loginGoogleUser(token);
      const responseCode = response.response && response.response.code;

      if (responseCode === '2000') {
        Cookies.save(
          COOKIES.customerToken,
          response.response.data.customerToken,
          {
            ...commonCookiesOptions,
            COOKIE_SUBSCRIBED_EXPIRES,
          },
        );

        subscribeGoogleUser(email, registration);
        onGoogleLoginSuccess(authTwo, dispatch);
      } else if (responseCode === '2002') {
        registerOneTapUser({
          authTwo,
          dispatch,
          email,
          registration,
          toast,
          token,
        });
      } else if (responseCode === '2001') {
        dispatch(setLoadingState(LOADING_STATUS.READY));
        showErrorToast(
          response.response.message || INVALID_GOOGLE_TOKEN_ID,
          toast,
        );
      } else {
        dispatch(setLoadingState(LOADING_STATUS.READY));
        showErrorToast(AN_ERROR_OCCURED, toast);
      }
    } catch (error) {
      dispatch(setLoadingState(LOADING_STATUS.READY));
      showErrorToast(error.message || AN_ERROR_OCCURED, toast);
    }
  };
  const handleSuccess = (response) => {
    const token = response?.credential;
    const decodedToken = jwt_decode(response.credential);
    const email = decodedToken?.email;
    setUserEmail(email);

    loginOneTapUser({ dispatch, email, registration, toast, token });
    // Add tracking
    trackEvent('google_one_tap_sign_in');

    setCookie({
      expire: 365,
      key: COOKIES.userEmail,
      value: email,
    });
  };

  const callDigiohLightbox = () => {
    const [, queryString] = router.asPath.split(/\?|#/g);
    // Dont show Lightbox on organic guides page
    if (!queryString) {
      const isGuideURL = /\/guides/i;
      if (isGuideURL.test(document.location.href)) {
        return;
      }
    }
    const searchParameters = new URLSearchParams(queryString?.toLowerCase());
    const itoValue = searchParameters.get('ito');

    // Additional code for suppressing Digioh added from DTM's code

    const urlToExclude = /\/ppc|\/checkout|\/faqs|\/merchantfaqs|\/wowcher-dream-job\/wowcher-affiliates|marketplace.wowcher.co.uk|\/welcome|refer-a-friend|\/internetsafety/i;
    // Removed wowcher_social_dyn-ret-new|wowcher_social_%20dyn-ret-new for testing
    const lbSupressedChannels = /tth_salesgen|wowcher_affiliate|criteo|awin|wowcher_cloudiq|salescycle|tth-dyn-ret|catalogue_2020|wowcher_retarget/i;
    const lbReactRegex = /_react_r|_react_a|_react2_r|_react2_a|_urlstart.*urlend/i;
    const dodSessionSourceValue = Cookies.load(COOKIES.sessionSource)?.replace(
      lbReactRegex,
      '',
    );

    const lbFromEmail =
      (dodSessionSourceValue?.includes('wowcher_email') ||
        window.location.href.includes('/email-deals') ||
        document.location.search.includes('wowcher_email_') ||
        document.location.search.includes('livingsocial_email_')) &&
      !dodSessionSourceValue?.includes('dealzippy_new');

    let channelOK = true;

    if (dodSessionSourceValue?.length > 0) {
      if (lbSupressedChannels.test(dodSessionSourceValue)) {
        channelOK = false;
      } else {
        channelOK = true;
      }
    }

    if (
      channelOK &&
      !urlToExclude.test(document.location.href) &&
      (!lbFromEmail ||
        itoValue?.toLowerCase().includes('wowcher_email_mg_wpbls_')) &&
      itoValue !== 'wowcher_affiliate_' &&
      itoValue !== 'wowcher_email_' &&
      itoValue !== 'wowcher_retarget_display_rtbhouse' &&
      itoValue !== 'wowcher_retarget_display_criteo' &&
      itoValue !== 'wowcher_wpush' &&
      itoValue !== 'wowcher_native_taboola' &&
      itoValue !== 'tth-dyn-ret-'
    ) {
      Cookies.save(COOKIES.locationPage, isLocationPage);
      console.log('called Digioh lightbox 2');
      // Call digioh lightbox barring the above conditions
      window?.DIGIOH_API?.showLB(window.DIGIOH_API.lb_type);
      setTimeout(() => {
        handleLightboxLocation();
      }, 500);
    }
  };

  const callLivingSocialLightbox = () => {
    const [, queryString] = router.asPath.split(/\?|#/g);
    const searchParameters = new URLSearchParams(queryString?.toLowerCase());
    const itoValue = searchParameters.get('ito');

    // Additional code for suppressing lightbox added from DTM's code
    const lbFromEmail =
      document.location.pathname.includes('/email-deals') ||
      document.location.search.includes('livingsocial_email_');
    const urlToExclude = /\/ppc|\/checkout|\/cashback|\/affiliates-livingsocial|\/faqs|\/merchantfaqs|\/welcome|marketplace.wowcher.co.uk|\/internetsafety/i;
    const lbSupressedChannels = /social_dyn_ret|livingsocialuk_affiliates|livingsocialie_affiliates|retarget_display|criteo_all-user_browse-abandon|awin|livingsocial_cloudiq|salescycle|email|wpush/i;
    const lbReactRegex = /_react_r|_react_a|_react2_r|_react2_a/i;
    const lbFromChannelValue = Cookies.load(COOKIES.sessionSource)?.replace(
      lbReactRegex,
      '',
    );
    let channelOK = true;

    if (lbFromChannelValue?.length > 0) {
      if (lbSupressedChannels.test(lbFromChannelValue)) {
        channelOK = false;
      } else {
        channelOK = true;
      }
    }

    const preventLBShowAB = Cookies.load(COOKIES.lsIELightBox) === 'b';

    if (
      process.env.NEXT_PUBLIC_SITE === SITE_LIVINGSOCIAL_IE &&
      preventLBShowAB
    ) {
      channelOK = false;
    }

    if (
      (channelOK ||
        itoValue?.toLowerCase().includes('wowcher_email_mg_wpbls_')) &&
      !urlToExclude.test(document.location.href) &&
      (!lbFromEmail ||
        itoValue?.toLowerCase().includes('wowcher_email_mg_wpbls_')) &&
      !itoValue?.match(/^livingsocial_email.+$/) &&
      !itoValue?.match(/^ls.+_email.+$/) &&
      !itoValue?.match(/^livingsocial.+_affiliates.+$/) &&
      !itoValue?.match(/^livingsocial.+_wpush.+$/) &&
      !itoValue?.match(/^livingsocial.+_retarget_display.+$/)
    ) {
      console.log('called LS lightbox');
      dispatch(setLightbox(true));
    }
  };
  const onOneTapSignedIn = (response) => {
    setShowText(false);
    handleSuccess(response);
  };

  const initializeGSI = () => {
    google.accounts.id.initialize({
      callback: onOneTapSignedIn,
      cancel_on_tap_outside: false,
      client_id: CLIENT_ID,
      prompt_parent_id: 'g_id_onload',
      use_fedcm_for_prompt: true, // Flag for FedCM
    });

    let supportsFedCmMode = false;

    try {
      if (navigator.credentials && navigator.credentials.get) {
        navigator.credentials
          .get({
            identity: Object.defineProperty({}, 'mode', {
              get() {
                supportsFedCmMode = true;

                return true;
              },
            }),
          })
          .catch(() => {
            console.warn('FedCM check failed or unsupported.');
          });
      }
    } catch (error) {
      console.warn('Error while checking FedCM support:', error);
    }

    if (supportsFedCmMode) {
      console.log(`~ FedCM supported ~`);
      trackEvent('google_one_tap_displayed');
    }

    google.accounts.id.prompt((notification) => {
      const momentType = notification.getMomentType(); // Use getMomentType()
      switch (momentType) {
        case 'not_displayed':
          console.log(notification.getNotDisplayedReason());
          handleOneTapClosed();
          break;
        case 'skipped':
          console.log(notification.getSkippedReason());
          trackEvent('google_one_tap_close');
          handleOneTapClosed();
          break;
        case 'dismissed':
          console.log(notification.getDismissedReason());
          if (notification.getDismissedReason() !== 'flow_restarted') {
            setShowText(false);
          }
          if (
            wowcherOrVoucher !== 'Wowcher' &&
            notification.getDismissedReason() === 'cancel_called' &&
            isLightBoxAllowed() &&
            !customerToken
          ) {
            callLivingSocialLightbox();
          }
          break;
        case 'display':
          console.log('google one tap displayed');
          trackEvent('google_one_tap_displayed');
          setTimeout(() => {
            const iframe = document.querySelector('#credential_picker_iframe');
            const iframeDesktop = document.querySelector(
              '#credential_picker_container',
            );

            if (iframe && iframe.style) {
              const iframeHeight = iframe.style.height;
              const displayIframe = iframe.style.display;

              if (iframeHeight) {
                mobileHeight = iframeHeight.slice(
                  0,
                  Math.max(0, iframeHeight.length - 2),
                );
                setBottomMargin(mobileHeight);
              }

              if (isIframeVisible(iframe) && displayIframe !== 'none') {
                setShowText(true);
              }
            }

            if (iframeDesktop && iframeDesktop.style) {
              const iframeDesktopHeight = iframeDesktop.style.height;
              const displayIframeDesktop = iframeDesktop.style.display;

              if (iframeDesktopHeight) {
                const desktopHeight = iframeDesktopHeight.slice(
                  0,
                  Math.max(0, iframeDesktopHeight.length - 2),
                );
                setTopMargin(desktopHeight);
              }

              if (
                isIframeVisible(iframeDesktop) &&
                displayIframeDesktop !== 'none'
              ) {
                setShowText(true);
              }
            }
          }, 2_000);
          setShowText(true);
          break;
        default:
          console.warn('Unknown One-Tap moment type:', momentType); // Handle unexpected cases
      }
    });
  };

  const handleOneTapClosed = () => {
    setShowText(false);
    removeCookie(COOKIES.googleOneTap);
    if (isLightBoxAllowed() && !customerToken) {
      callDigiohLightbox();
    }
    if (
      wowcherOrVoucher !== 'Wowcher' &&
      isLightBoxAllowed() &&
      !customerToken
    ) {
      callLivingSocialLightbox();
    }
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.setAttribute('data-use_fedcm_for_prompt', 'true'); // For FedCM

    script.onload = () => {
      console.log('Google One Tap script loaded');
      initializeGSI();
    };

    script.onerror = () => {
      console.error('Failed to load Google Sign-in library');
      setShowText(false); // Hide text on error
    };

    document.body.appendChild(script);

    const timer = setTimeout(() => {
      console.log('Google One Tap timeout triggered');
      if (window.google?.accounts?.id) {
        google.accounts.id.cancel();
      } else {
        console.error(
          'Google Identity Services library is not loaded (timeout).',
        );
      }
      handleOneTapClosed(); // Call the common close handler
    }, 8_000);

    return () => {
      clearTimeout(timer);
      document.body.removeChild(script); // Clean up
    };
  }, []);

  const DEFAULT_LINK =
    LINKS_GLOBAL_WOWCHER[process.env.NEXT_PUBLIC_ENVIRONMENT || 'prod'][
      process.env.NEXT_PUBLIC_SITE || 'wowcher'
    ];

  return (
    <>
      {showText && showConfirmation === 'b' && (
        <>
          <div className="sticky-text-content">
            <div>
              {
                'Submit your email address to subscribe to receive daily emails featuring local service, shopping and travel offers from Wowcher. You can change your preferences or unsubscribe at any time by visiting our email preference centre or by clicking on the unsubscribe option, both of which are links in each of our emails. View our Privacy & Cookie Policy '
              }
              <a
                href={`${DEFAULT_LINK}/page/privacypolicy`}
                rel="noreferrer noopener"
                target="_blank"
              >
                {'HERE'}
              </a>
            </div>
          </div>
        </>
      )}
      <style global jsx>{`
        @media (min-width: 240px) {
          .sticky-text-content {
            font-size: 12px;
            position: fixed;
            z-index: 9999;
            text-align: center;
            border-radius: 8px;
            bottom: ${bottomMargin - 10}px;
            width: 100%;
            background-color: #fff;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
            padding: 5px;
          }
        }
        @media (min-width: 769px) {
          .sticky-text-content {
            font-size: 12px;
            position: fixed;
            width: 375px;
            right: 29px;
            top: ${Number(topMargin) + 10}px;
            bottom: auto;
            z-index: 9999;
            text-align: center;
            border-radius: 8px;
          }
        }
      `}</style>
    </>
  );
};

GoogleOneTap.propTypes = {
  registration: PropTypes.bool,
  setIsNewUser: PropTypes.func,
  setUserEmail: PropTypes.func,
};

export default GoogleOneTap;
